import AdminGate from "@components/pages/AdminDashboard";
import CheckoutPage from "@components/pages/CheckoutPage";
import Consultation from "@components/pages/Consultation/Consultation";
import Dashboard from "@components/pages/Dashboard/Dashboard";
import ForgotPasswordPage from "@components/pages/ForgotPassword";
import Consent from "@components/pages/LegalDocuments/Consent";
import Privacy from "@components/pages/LegalDocuments/Privacy";
import Terms from "@components/pages/LegalDocuments/Terms";
import LoginPage from "@components/pages/LoginPage";
import docViewer from "@components/pages/LoginPage/docs/docViewer";
import SecurityCodePage from "@components/pages/PasswordReset";
import SignupPage from "@components/pages/SignupPage";
import ThankYou from "@components/pages/ThankYou/ThankYou";

export const pages = {
  AdminGate,
  LoginPage,
  SignupPage,
  CheckoutPage,
  Dashboard,
  docViewer,
  Privacy,
  Terms,
  Consent,
  ForgotPasswordPage,
  SecurityCodePage,
  ThankYou,
  Consultation,
};
